import { MouseEventHandler } from "react"
import styles from "./FilterButton.module.css"

interface filterButtonProps {
    title: string
    onClick?: MouseEventHandler<HTMLButtonElement> | undefined
    form?: string | undefined
    isOpen: boolean
}

export default function FilterButton({title, onClick, form, isOpen}: filterButtonProps) {
    return(
        <button onClick={onClick} form={form} className={`${styles.btn} ${isOpen ? styles.open : styles.closed}`}>{title}
            <span className={styles.arrow}></span>
        </button>
    )
}